// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Header from './Classes/Header';
import CategoryLoader from './Classes/CategoryLoader';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import ResponsiveTable from "./Classes/ResponsiveTable";
import LazyLoad from './Classes/Lazyload';
import NoLine from "./Classes/NoLine";
import smoothscroll from 'smoothscroll-polyfill';
import SustainabilityTabs from "./Classes/SustainabilityTabs";
import Swiper from "./lib/swiper"
import Anchor from "./Classes/Anchor";
import NoHeader from "./Classes/NoHeader";

import Counter from "./Classes/Counter";
import CounterInSwiper from "./Classes/CounterInSwiper";

import Video from './Classes/Video';
import SliderHandler from './Classes/SliderHandler';
import SliderArrowCenter from './Classes/SliderArrowCenter';
import AnchorPDF from "./Classes/AnchorPDF";

(function () {
  document.addEventListener('DOMContentLoaded', () => {


    new Accordion({
      accordions: '.ns-accordion'
    });

    new Header();
    new CategoryLoader();
    new FocusHandler();
    new LazyLoad();

    new NoLine();
    new NoHeader();
    new SustainabilityTabs({
        tabButtonSelector: '.sustainability__button',
        tabSelector: '.sustainabiltity__tab'
      }
    );

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new AnchorPDF({
      anchorSelector: '.ns-anchor'
    });

    smoothscroll.polyfill();
    new Anchor();

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    const sliderContainer = document.querySelector('.swiper-container');
    if ( sliderContainer && sliderContainer != undefined) {
      Helper.loadImagesInDomElement(sliderContainer);
    }

    new Swiper('.swiper-outer .swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });


    /*
    new Swiper('.ns-keyfigures__inner', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    */

    var keyfigureInstance = new Swiper('.ns-keyfigures-slider:not(.content-width) .swiper-container', {
      // Default parameters
      touchEventsTarget: 'container',
      watchSlidesVisibility: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView: 1,
      visibilityFullFit: true,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 3
        },
        1201: {
          slidesPerView: 4
        }
      }
    });

    var keyfigureInstanceContentWidth = new Swiper('.ns-keyfigures-slider.content-width .swiper-container', {
      // Default parameters
      touchEventsTarget: 'container',
      watchSlidesVisibility: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView: 1,
      visibilityFullFit: true,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 3
        }
      }
    });

    var counterInSwiperInstance = new CounterInSwiper({
      keyfigureInstance: keyfigureInstance,
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    var counterInSwiperInstanceContentWidth = new CounterInSwiper({
      keyfigureInstance: keyfigureInstanceContentWidth,
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    new Counter({
      container: '.ns-keyfigures:not(.ns-keyfigures--no-upcounting)',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    new Video();

    var sliderInstance = new SliderHandler({
      sliderType: 'slideWithTab',
      outerWrapperSelector: '.ns-slider-wrapper'
    });

    var swiperInstances = sliderInstance.getInstances();

    new SliderArrowCenter({
      outerWrapperSelector: '.ns-slider-wrapper',
      heightItem: '.swiper-slide-active .ns-slide-tile__image',
      swiperInstances: swiperInstances,
      sliderBreakpointMax: 768
    });

  })
})();
